import { apiClient } from '@/lib/api-client';

export interface CertMeta {
  hasCertificate: boolean;
  commonName: string | null;
  serialNumber: string | null;
  notBefore: string | null;
  notAfter: string | null;
  sunatSolUser: string | null;
  daysUntilExpiry: number | null;
}

export async function getCertMeta(): Promise<CertMeta> {
  const { data } = await apiClient.get<CertMeta>('/certificates/me');
  return data;
}

export async function uploadCert(input: {
  pfxBase64: string;
  pfxPassword: string;
  sunatSolUser?: string;
  sunatSolPassword?: string;
}): Promise<CertMeta> {
  const { data } = await apiClient.post<CertMeta>('/certificates', input);
  return data;
}
